export default "__VITE_ASSET__16317467__"